export enum ImageSizes {
    SMALL = 56,
    LARGE = 168,
    COVER = 248,
}
